import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const STATUSES = ["available", "limited", "unavailable", "confirmed", "personal"];

export default function AdminAvailability() {
  const [list, setList] = useState([]);
  const [date, setDate] = useState("");
  const [status, setStatus] = useState("available");
  const [note, setNote] = useState("");

  const load = async () => {
    const { data } = await api.get("/admin/availability");
    setList(data || []);
  };
  useEffect(() => { load(); }, []);

  const upsert = async () => {
    if (!date) return toast.error("Pick a date");
    await api.put("/admin/availability", { date, status, note });
    toast.success("Saved");
    setDate(""); setStatus("available"); setNote("");
    load();
  };

  const remove = async (d) => {
    if (!window.confirm(`Remove availability entry for ${d}?`)) return;
    await api.delete(`/admin/availability/${d}`);
    load();
  };

  return (
    <div data-testid="admin-availability">
      <p className="label-mono opacity-60">Calendar</p>
      <h1 className="mt-2 font-editorial text-5xl md:text-6xl">Availability</h1>

      <div className="mt-10 flex flex-wrap items-end gap-4 max-w-3xl">
        <div><label className="label-mono opacity-60">Date</label><input type="date" className="editorial-input" value={date} onChange={(e) => setDate(e.target.value)} data-testid="availability-date" /></div>
        <div>
          <label className="label-mono opacity-60">Status</label>
          <select className="editorial-select" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="availability-status">
            {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <div className="flex-1 min-w-[240px]"><label className="label-mono opacity-60">Note (private)</label><input className="editorial-input" value={note} onChange={(e) => setNote(e.target.value)} data-testid="availability-note" /></div>
        <button onClick={upsert} className="btn-solid" data-testid="availability-save">Set</button>
      </div>

      <div className="mt-10 border border-ink/15 bg-white divide-y divide-ink/10">
        {list.length === 0 && <p className="p-6 label-mono opacity-60">No availability entries yet.</p>}
        {list.map((a) => (
          <div key={a.date} className="p-4 flex items-center justify-between gap-4" data-testid={`availability-row-${a.date}`}>
            <div>
              <p className="font-editorial text-lg">{a.date}</p>
              <p className="label-mono opacity-60 mt-1">{a.status} {a.note ? "· " + a.note : ""}</p>
            </div>
            <button onClick={() => remove(a.date)} className="label-mono opacity-70 hover-underline">Remove</button>
          </div>
        ))}
      </div>
    </div>
  );
}
